export class DataCatalogDatasetSchema {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<DataCatalogDatasetSchemaColumnsInner>",
            "format": ""
        },
        {
            "name": "rowCount",
            "baseName": "rowCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "sizeBytes",
            "baseName": "sizeBytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogDatasetSchema.attributeTypeMap;
    }
    constructor() {
    }
}
